import type { CityConfig } from "../city-template/types";

export const highlandParkConfig: CityConfig = {
  city: "Highland Park",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "highland-park",
  route: "/cities/highland-park",
  title: "Emergency Passport Highland Park, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Highland Park, Illinois — as fast as 24 hours. Fast passport renewal for North Shore residents and all Lake County travelers. A+ BBB rated registered State Dept. courier serving Highland Park, Lake Forest, and the entire North Shore.",
  h1: "Emergency & Expedited Passport Services in Highland Park, IL",
  heroSubtitle: "North Shore family heading to Ravinia Festival's international artist lineup and your passport's expired? Lake Forest business traveler with a last-minute European client meeting? Highland Park resident with a summer trip to Tuscany and no valid passport? We help Highland Park residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving the North Shore and southeastern Lake County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Highland%20Park%20Illinois%20North%20Shore%20downtown%20with%20elegant%20Central%20Avenue%20and%20boutique%20storefronts%20under%20mature%20shade%20trees%2C%20the%20Ravinia%20Festival%20park%20with%20historic%20pavilion%20and%20manicured%20lawns%20under%20summer%20evening%20lights%2C%20Lake%20Michigan%20shoreline%20from%20the%20North%20Shore%20bluffs%20with%20scenic%20overlooks%20and%20beach%20access%2C%20classic%20brick%20and%20stone%20residential%20architecture%20in%20Fort%20Sheridan%20and%20historic%20neighborhoods%2C%20commuter%20Metra%20station%20on%20the%20Union%20Pacific%20North%20Line%2C%20lush%20green%20parks%20and%20ravines%20characteristic%20of%20North%20Shore%20landscape&width=1800&height=700&seq=highland-park-hero-001&orientation=landscape",
  heroImageAlt: "Highland Park Illinois downtown and Lake Michigan North Shore landscape",
  geoPosition: "42.1817;-87.8003",
  geoPlacename: "Highland Park, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 40 minutes south of Highland Park via I-94",
  },
  nearbyCitiesZips: [
    { name: "Highland Park", zips: "60035" },
    { name: "Lake Forest", zips: "60045" },
    { name: "Deerfield", zips: "60015" },
    { name: "Glencoe", zips: "60022" },
    { name: "Winnetka", zips: "60093" },
    { name: "Northbrook", zips: "60062" },
    { name: "Glenview", zips: "60025, 60026" },
    { name: "Bannockburn", zips: "60015" },
    { name: "Riverwoods", zips: "60015" },
    { name: "Lincolnshire", zips: "60069" },
    { name: "Buffalo Grove", zips: "60089" },
    { name: "Wheeling", zips: "60090" },
    { name: "Prospect Heights", zips: "60070" },
    { name: "Vernon Hills", zips: "60061" },
    { name: "Libertyville", zips: "60048" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 40 minutes south via I-94, but you skip the downtown trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for North Shore and Lake County travelers" },
    { icon: "ri-building-2-line", title: "North Shore Premium", desc: "Serving Highland Park, Lake Forest, and the entire North Shore with white-glove passport expediting" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from UPS Store on Central Avenue or any FedEx in Highland Park — no downtown Chicago trip" },
  ],
  internalLinks: [
    { name: "Expedited passport in Evanston, IL", route: "/cities/evanston" },
    { name: "Emergency passport help in Waukegan, IL", route: "/cities/waukegan" },
    { name: "Urgent passport services in Glenview, IL", route: "/cities/glenview" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Highland Park, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (40 minutes south via I-94) — without you dealing with Lake Shore Drive traffic and Loop parking. Highland Park residents can ship from the UPS Store on Central Avenue or any FedEx location. For North Shore families and professionals, our courier service saves hours and the frustration of downtown Chicago navigation.",
  fpcOfficeDistance: "Serving Highland Park, Lake Forest, Deerfield, Glencoe, Winnetka, Northbrook, Glenview, Bannockburn, Riverwoods, Lincolnshire, Buffalo Grove, Wheeling, Prospect Heights, Vernon Hills, Libertyville, and the entire North Shore region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Highland Park and the entire North Shore region. From the elegant Central Avenue downtown and Ravinia Festival neighborhood to the lakefront estates and residential communities — we serve southeastern Lake County and the entire North Shore.",
  nearbyCitiesIntro: "We serve Highland Park and all nearby communities including Lake Forest, Deerfield, Glencoe, Winnetka, Northbrook, Glenview, Bannockburn, Riverwoods, Lincolnshire, Buffalo Grove, Wheeling, Prospect Heights, Vernon Hills, and Libertyville.",
  howItWorksIntro: "Most Highland Park travelers complete everything online and ship documents overnight. No need to drive downtown to the Loop — our couriers handle the Chicago Passport Agency trip for you. For North Shore families planning international vacations and professionals with business travel, our service saves valuable time.",
  mistakesIntro: "Highland Park is one of the North Shore's most international communities, with residents frequently traveling for business and leisure — yet even sophisticated travelers make these passport mistakes. Here are the most common ones in Highland Park and the North Shore.",
  testimonialsIntro: "Highland Park travelers — from North Shore families heading to Europe and Ravinia international visitors to Lake Forest business executives and Highland Park professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Highland Park, IL? Here are the most common ones we hear from North Shore residents.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Downtown Chicago traffic via Edens Expressway", "Time-consuming for North Shore residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No downtown Chicago traffic or parking required", "Perfect for North Shore international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Highland Park travelers with immediate departure needs — as fast as 24 hours. Essential for North Shore families and professionals with urgent international travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No downtown Chicago trip — ship from Central Avenue"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Highland Park adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Highland Park address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Highland Park residents — young adults, new citizens, and North Shore families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Highland Park residents who lost their passport before an international trip.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Highland Park, Lake Forest, and North Shore families traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Highland Park and North Shore residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Highland Park residents who need land/sea travel to Canada or Mexico — convenient for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Highland Park residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Highland Park business executives and frequent international travelers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Highland Park IL", description: "Urgent passport processing for Highland Park Illinois travelers and North Shore residents with immediate departure needs." },
    { name: "Expedited Passport Renewal Highland Park IL", description: "Fast passport renewal for Highland Park Illinois residents and North Shore travelers." },
    { name: "First-Time Passport Highland Park IL", description: "New passport application services for Highland Park Illinois residents." },
    { name: "Child Passport Highland Park IL", description: "Minor passport services for Highland Park Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Catherine W.",
      location: "Highland Park, IL",
      rating: 5,
      text: "Family trip to Paris over spring break — realized 2 weeks before that my passport expired during COVID and the kids needed renewals too. Fast Passport Center handled all 3 in 5 days. Shipped from Central Avenue. The thought of driving downtown Chicago with 3 kids for passport stuff was a nightmare. North Shore moms, this is the only way.",
      service: "Family Passport Package",
    },
    {
      name: "Jonathan S.",
      location: "Highland Park, IL — Investment Banking",
      rating: 5,
      text: "Client meeting in Zurich — 4 days notice. My passport was valid but had only 4 months left (Switzerland requires 6). Fast Passport Center renewed it in 2 days. No way I was spending a morning in Loop traffic. This service is practically designed for North Shore finance professionals.",
      service: "Passport Renewal",
    },
    {
      name: "The Adler Family",
      location: "Lake Forest, IL",
      rating: 5,
      text: "Summer trip to Tuscany — the villa was booked but our daughter's first passport application got complicated. Fast Passport Center walked us through the whole DS-11 process and had it in 4 days. Highland Park post office was easy. Lake Forest and Highland Park families, don't even think about going downtown.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "hpk-1",
      name: "Highland Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "833 Central Ave",
      city: "Highland Park",
      state: "IL",
      zip: "60035",
      phone: "(847) 432-0667",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Highland Park, downtown on Central Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Highland Park acceptance facility on Central Avenue in the heart of downtown. Convenient to Metra station, Ravinia Festival area, and Central Avenue shopping. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hpk-2",
      name: "Lake Forest Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "249 Market Sq",
      city: "Lake Forest",
      state: "IL",
      zip: "60045",
      phone: "(847) 234-4771",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lake Forest, approximately 4 miles north of Highland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lake Forest and northern North Shore communities. Located in historic Market Square. Convenient for Lake Forest College and Lake Forest Academy families. Good alternative with extended hours.",
      icon: "ri-mail-line",
    },
    {
      id: "hpk-3",
      name: "Deerfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "707 Osterman Ave",
      city: "Deerfield",
      state: "IL",
      zip: "60015",
      phone: "(847) 945-0426",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Deerfield, approximately 5 miles west of Highland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Deerfield and western North Shore communities. Convenient for residents near Deerfield Road corridor and Bannockburn. Good alternative with extended hours.",
      icon: "ri-mail-line",
    },
    {
      id: "hpk-4",
      name: "Glencoe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "336 Hazel Ave",
      city: "Glencoe",
      state: "IL",
      zip: "60022",
      phone: "(847) 835-4429",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Glencoe, approximately 5 miles south of Highland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Glencoe and southern North Shore lakefront communities. Convenient for Highland Park residents near the lakefront. Smaller facility with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "hpk-5",
      name: "Northbrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2460 Dundee Rd",
      city: "Northbrook",
      state: "IL",
      zip: "60062",
      phone: "(847) 272-1745",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Northbrook, approximately 7 miles southwest of Highland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Northbrook and southwestern North Shore communities. Convenient for Highland Park residents near the southern border. Good alternative with extended hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Chicago, Loop area", fpc: "No — ship from Central Avenue" },
    { feature: "Time Commitment", agency: "2+ hours with Edens traffic", fpc: "Minutes — ship from downtown Highland Park" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for N. Shore", agency: "No — Edens Expressway is a time sink", fpc: "Yes — the premium choice" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Ravinia Season Rush",
      description: "Highland Park's world-famous Ravinia Festival attracts international visitors — and local residents often plan European trips around the summer season, only to discover passport problems at the last minute. Even with Chicago just 40 minutes away, the round trip with traffic is a huge time commitment during busy summer months.",
    },
    {
      icon: "ri-road-map-line",
      title: "Edens Expressway Traffic Reality",
      description: "Highland Park to downtown Chicago is only 40 minutes on paper — but the Edens Expressway (I-94) during rush hour can easily add 30-40 minutes each way. What looks like a quick trip can become a 3-hour ordeal with Loop parking and security. For North Shore residents, time is precious — our courier service respects that.",
    },
    {
      icon: "ri-passport-line",
      title: "Summer Travel Blind Spots",
      description: "Many Highland Park families book summer European vacations in January but don't check passports until May. With summer being peak passport season, processing times stretch. Start your passport renewal at least 3-4 months before summer travel — or use our courier service for last-minute situations.",
    },
    {
      icon: "ri-image-line",
      title: "Passport Photo Standards",
      description: "North Shore residents sometimes assume retail store photos are automatically compliant — they're not. Background must be pure white, no shadows, no glasses (since 2016), head sized correctly. Use UPS Store on Central Avenue or a professional passport photo service. A rejection costs days you don't have.",
    },
    {
      icon: "ri-file-list-line",
      title: "Name Change Oversights",
      description: "After marriage or divorce, many Highland Park residents forget their passport still has their old name. Airlines will deny boarding if your passport name doesn't match your ticket. If you've had a legal name change, get your passport updated before booking international flights.",
    },
    {
      icon: "ri-global-line",
      title: "Lost or Stolen Passport Reporting",
      description: "If your passport is lost or stolen in Highland Park, you MUST file Form DS-64 in addition to your replacement application (DS-11). Many residents only fill out the DS-11 and get rejected. Our document review ensures both forms are complete before submission — preventing a 3+ week delay.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home, office, or anywhere in Highland Park." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at UPS Store on Central Avenue or any FedEx in Highland Park." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with North Shore family travel, executive business needs, and international leisure trips." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 40 minutes away but you never make the downtown trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Highland Park address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Highland Park, IL?", a: "Fast Passport Center offers emergency passport processing in Highland Park, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (40 minutes south via I-94) — without you dealing with Edens Expressway traffic, Loop parking, and security lines." },
    { q: "Is it worth using a courier when Chicago is only 40 minutes from Highland Park?", a: "Absolutely. While the distance is short on a map, the real-world experience involves I-94/Edens congestion, downtown parking ($30-40), building security, and waiting — easily 2-3 hours door-to-door. Plus, agency appointments book weeks out for non-emergencies. For North Shore residents who value their time, our courier service is the clear choice." },
    { q: "Do you serve the Ravinia Festival community?", a: "Yes — Highland Park is home to the world-renowned Ravinia Festival, and we serve residents throughout the Ravinia neighborhood, downtown Highland Park, and the surrounding North Shore communities. Whether you're a year-round resident or seasonal visitor, we provide fast passport services for your international travel needs." },
    { q: "What airport do Highland Park travelers use?", a: "Chicago O'Hare International Airport (ORD) is approximately 25 minutes southwest via I-94/I-294. Chicago Midway (MDW) is approximately 40 minutes south. Most North Shore international travelers prefer ORD for its extensive global connections and proximity to the northern suburbs." },
    { q: "Can I use the Highland Park post office for fast passport service?", a: "The Highland Park post office on Central Avenue can accept DS-11 applications for first-time passports but has no ability to expedite processing. They mail applications through standard channels. For travel within 10 weeks, our courier service is the only practical fast option." },
    { q: "Can I get my child's passport expedited in Highland Park?", a: "Yes. Fast Passport Center expedites child passports in Highland Park for minors under 16. Both parents must appear or submit notarized consent. We guide North Shore families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Highland Park?", a: "The UPS Store on Central Avenue offers passport photos. Walgreens on Skokie Valley Road and CVS also provide photo services. The Highland Park Post Office may offer photos by appointment. Photos must be 2x2 inches on a white background." },
  ],
  photoLocations: [
    { name: "UPS Store — Highland Park", address: "600 Central Ave, Highland Park, IL 60035", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Highland Park", address: "1500 Skokie Valley Rd, Highland Park, IL 60035", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Highland Park", address: "1600 Deerfield Rd, Highland Park, IL 60035", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Highland Park Post Office", address: "833 Central Ave, Highland Park, IL 60035", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Deerfield", address: "425 Lake Cook Rd, Deerfield, IL 60015", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. About 5 minutes west of Highland Park via Lake Cook Road. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Waukegan", address: "617 S Green Bay Rd, Waukegan, IL 60085", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Waukegan and Lake County. REAL ID processing available. About 20 minutes north — good alternative with generally shorter wait times.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Lake County birth and death certificates" },
    { label: "Marriage Licenses (Lake County Clerk)", url: "https://www.lakecountyil.gov/148/County-Clerk", desc: "Lake County Clerk — marriage license applications and certified copies for Highland Park and North Shore" },
    { label: "Divorce Decrees (Lake County Circuit Clerk)", url: "https://www.lakecountyil.gov/218/Circuit-Clerk", desc: "Lake County Circuit Clerk — divorce decree records for Highland Park and Lake County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 25 minutes southwest via I-94/I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. The closest and preferred airport for North Shore international travelers. About 25 minutes from Highland Park via the Tri-State Tollway.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 40 minutes south via I-94/I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with extensive domestic and some international routes. About 40 minutes from Highland Park. Good for Southwest domestic connections and Mexico/Caribbean destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};